<template>
	<div class="list-container column">
		<div class="title">
			Inventarier för våning: {{ title }}
		</div>
		<div class="panel-list-header">
			<div class="panel-filler" v-if="$isAllowedTo('floor_areas_edit')" />
			<div class="panel-header-item pos">Pos nr</div>
			<div class="panel-header-item">Namn</div>
			<div class="panel-header-item">Årtal</div>
			<div class="panel-filler" v-if="$isAllowedTo('floor_areas_edit')" />
			<div class="panel-filler" v-if="$isAllowedTo('floor_areas_edit')" />
		</div>
		<div
			class="panel-list"
			v-for="item in items"
			:key="item.id"
			@click.stop="onEditItem(item)"
		>
			<div class="panel-list-buttons" v-if="$isAllowedTo('floor_areas_edit')">
				<div class="positioner-container">
					<div class="positioner" @click.stop="position(item, -1)">
						<i class="fas fa-sm fa-minus"></i>
					</div>
					<div class="positioner" @click.stop="position(item, 2)">
						<i class="fas fa-sm fa-plus"></i>
					</div>
				</div>
			</div>
			<p class="panel-list-item pos">{{ item.positionNumber }}</p>
			<p class="panel-list-item">{{ item.fireProtection.name }}</p>
			<p class="panel-list-item">{{ getYear(item) }}</p>
			<div
				class="list-button"
				v-if="$isAllowedTo('floor_areas_edit')"
				@click.stop="onEditItem(item)"
			>
				<i class="fas fa-edit"></i>
			</div>
			<div
				class="list-button"
				v-if="$isAllowedTo('floor_areas_edit')"
				@click.stop="onDeleteItem(item)"
			>
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="items.length == 0">
			<p class="panel-list-item">Inga resultat</p>
		</div>
		<Pagination
			v-if="items.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters, mapActions } from 'vuex';
export default {
	components: {
		Pagination
	},
	props: {
		map: Object,
		building: Object,
		items: Array,
		floor: Object
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('mapItemStore', ['pagination']),

		title() {
			return this.building.customer
				? `${this.floor.name} | ${this.building.name} | ${this.building.customer.name}`
				: '';
		},
		mapHasNoFile() {
			if (this.map) {
				if (this.map.file) {
					return false;
				}
			}

			return true;
		}
	},
	methods: {
		...mapActions('mapItemStore', ['setCurrentPage', 'setPageSize']),
		getYear(item) {
			let year = item.year.substring(0, 4);

			return year === '0001' ? '-' : year;
		},
		onDeleteMap() {
			this.$emit('delete-map', this.map);
		},
		onDeleteItem(item) {
			this.$emit('delete-item', item);
		},
		onEditMap() {
			this.$emit('edit-map', this.map);
		},
		onEditItem(item) {
			this.$emit('edit-item', item);
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('paginate');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('paginate');
		},
		position(item, index) {
			item.positionNumber = item.positionNumber + index;
			this.$emit('update', item);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.panel-list-item.pos,
.panel-header-item.pos {
  max-width: 80px;
}
.panel-list-buttons {
  min-width: 32px;
  position: relative;
  .positioner-container {
    position: absolute;
    top: -8px;
    .positioner {
      position: relative;
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      background: $info;
      text-align: center;
      border-radius: 2px;
      border: 1px solid $info-active;
      margin-bottom: 2px;
      &:hover {
        background: $white;
        i {
          color: $info;
        }
      }
      cursor: pointer;
      i {
        position: absolute;
        top: 2px;
        right: 15%;
        color: $white;
      }
    }
  }
}
</style>
